import api from "../api";

export async function fetchComptencyData(lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/competency/competency-category-data`,
  });
}

export async function GetQuestionBehaviourList(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/assessment-question-behaviour/${id}`,
  });
}
